<template>
  <div class="error-content">
    <div class="error-content__title">
      {{ $t('Errors.Er403') }}
    </div>
    <div
      class="ml-4 pt-4 pb-4 text-left h4-headline opacity-7">
      <div>{{ $t('Errors.NoAccessdText.0') }}</div>
      <div>{{ $t('Errors.NoAccessdText.1') }}</div>
    </div>
    <div
      class="error-content_btns"
      :description="description">
      <sButton
        v-if="availableOrganizations && availableOrganizations.length"
        class="error-content_btn"
        :to="{ name: 'homePage' }">
        {{ $t('Errors.ToHomePage') }}
      </sButton>
      <template v-if="!availableOrganizations || !availableOrganizations.length">
        <sButton
          class="error-content_btn"
          data-qa="btn-goTo-authorization"
          @click="$auth.signOut()">
          {{ $t('Menu.GoToAuthorization') }}
        </sButton>
        <sButton
          class="error-content_btn"
          data-qa="btn-goTo-registry"
          :href="linkRegistry">
          {{ $t('Menu.GoToRegistry') }}
        </sButton>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'error403',
  data() {
    return {
      route: {},
      linkRegistry: null
    }
  },
  computed: {
    ...mapGetters({
      availableOrganizations: 'getAvailableOrganizations',
    }),
    description() {
      return this.$route?.params?.descript
    }
  },
  mounted() {
    this.linkRegistry = this.$t('Menu.Link.Registry', { domen: window.config?.SmarttenderUrl })
  }
}
</script>
<style lang="scss" scoped>
.error-content {
  &__title {
    text-align: left;
    margin-left: 16px;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    @media (max-width:935px) {
      margin-left: 0;
      text-align: center;
    }
  }
  &_btns {
    margin-left: 16px;
    margin-top: 16px;
    display: flex;
    @media (max-width:935px) {
      display: grid;
      row-gap: 20px;
      max-width: 100%;
    }
  }
  &_btn {
    margin-left: 20px;
    &:nth-child(1) {
      margin-left: 0px;
    }
    @media (max-width:935px) {
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: 100%;
      width: 300px;
    }
  }
}
</style>
